import React from 'react';

import {MinimalFolder} from 'constants/FolderConstants';
import SelectTree from 'ui-library/select-tree/SelectTree';

import * as FileSelectorUtil from './FileSelectorUtil';

export interface RegistrySelectTreeProps {
  folderIds: Array<string>;
  onChangeSelectedFolders: (folderIds: Array<string>) => void;
  registries: Array<MinimalFolder>; // In this case, defined as a set of folder-like items.
  submitHandler: () => void;
}
export default function RegistrySelectTree({
  folderIds,
  onChangeSelectedFolders,
  registries,
  submitHandler,
}: RegistrySelectTreeProps): JSX.Element {
  return (
    <SelectTree
      items={FileSelectorUtil.registriesToSelectTreeItems(registries)}
      multiple={false}
      selectedIds={folderIds}
      onChangeSelectedIds={onChangeSelectedFolders}
      submitHandler={submitHandler}
    />
  );
}
